import { useState, useCallback } from 'react';
import axios from 'axios';
import { useLiveRefresh } from './useLiveRefresh.js';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8009';
const GEZIEN_KEY = 'havuncore-meldingen-gezien';

function leesGezien() {
    try {
        return Number(localStorage.getItem(GEZIEN_KEY)) || 0;
    } catch {
        return 0;
    }
}

/**
 * The pushes of the last 30 days (HavunCore push_meldingen), so a buzz on the
 * phone always has its text in the bell. Live through useLiveRefresh, same as the
 * health alerts.
 */
export function usePushMeldingen(token) {
    const [meldingen, setMeldingen] = useState([]);
    const [fout, setFout] = useState(null);
    const [gezien, setGezien] = useState(leesGezien);

    const refetch = useCallback(async () => {
        if (!token) return;
        try {
            const res = await axios.get(`${API_URL}/api/meldingen`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setMeldingen(res.data?.data || []);
            setFout(null);
        } catch (err) {
            console.error('Failed to load push history:', err);
            setFout('Pushberichten niet op te halen.');
        }
    }, [token]);

    useLiveRefresh(token, refetch);

    const markeerGezien = useCallback(() => {
        const nu = Date.now();
        setGezien(nu);
        try {
            localStorage.setItem(GEZIEN_KEY, String(nu));
        } catch { /* per-device convenience only */ }
    }, []);

    const nieuwCount = meldingen.filter((m) => new Date(m.created_at).getTime() > gezien).length;

    return { meldingen, nieuwCount, fout, markeerGezien };
}

export default usePushMeldingen;
